import s from "./index32.js";
import { resolveComponent as r, openBlock as c, createElementBlock as i, createElementVNode as o, createVNode as t } from "vue";
import "./index33.js";
import l from "../../../../_virtual/index.js";
const n = { class: "footer-skeleton-mobile" }, a = { class: "footer-row" }, d = { class: "footer-row" }, f = { class: "footer-row" }, m = { class: "footer-col" }, _ = { class: "footer-col" }, p = { class: "footer-col end-link" }, h = { class: "footer-row footer-disclaimer" };
function v(k, u, w, $, x, S) {
  const e = r("Shimmer");
  return c(), i("div", n, [
    o("div", a, [
      t(e, { class: "footer-item footer-small" })
    ]),
    o("div", d, [
      t(e, { class: "footer-item footer-medium" })
    ]),
    o("div", f, [
      o("div", m, [
        t(e, { class: "footer-item footer-link" })
      ]),
      o("div", _, [
        t(e, { class: "footer-item footer-link" })
      ]),
      o("div", p, [
        t(e, { class: "footer-item footer-link" })
      ])
    ]),
    o("div", h, [
      t(e, { class: "footer-disclaimer-item" })
    ])
  ]);
}
const V = /* @__PURE__ */ l(s, [["render", v], ["__scopeId", "data-v-a6ec10e5"]]);
export {
  V as default
};
//# sourceMappingURL=index29.js.map
